<!-- Button -->
<button [matMenuTriggerFor]="userActions" [matTooltip]="'Profile' | transloco" mat-icon-button>
  <span class="relative">
    <img *ngIf="showAvatar && user?.avatar" [src]="user?.avatar" class="w-7 h-7 rounded-full" />
    <mat-icon
      *ngIf="!showAvatar || !user?.avatar"
      [svgIcon]="'heroicons_outline:user-circle'"
    ></mat-icon>
    <span
      [ngClass]="{
        'mr-px mb-px': !showAvatar || !user?.avatar,
        'bg-green-500': user?.status === 'online',
        'bg-amber-500': user?.status === 'away',
        'bg-red-500': user?.status === 'busy',
        'bg-gray-400': user?.status === 'not-visible'
      }"
      class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
    ></span>
  </span>
</button>

<mat-menu #userActions="matMenu" [xPosition]="'before'" id="user-menu">
  <div (click)="$event.stopPropagation()" class="p-2 text-smaller">
    <span class="flex flex-col leading-none">
      <span>{{ 'signed in as' | transloco }}</span>
      <span class="mt-1.5 text-md font-medium">{{ user?.email }}</span>
    </span>
  </div>
  <div (click)="$event.stopPropagation()" *ngIf="user?.is_owner" class="p-2 text-smaller">
    <span class="flex flex-col leading-none">
      <span>{{ 'Your Project Balance' | transloco }} : {{ user?.balance }}</span>
    </span>
  </div>
  <mat-divider class="my-2"></mat-divider>

  <a [routerLink]="['/settings']" mat-menu-item>
    <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
    <span>{{ 'change Password' | transloco }}</span>
  </a>
  <a [routerLink]="['/settings/preferences']" mat-menu-item>
    <mat-icon [svgIcon]="'mat_solid:room_preferences'"></mat-icon>
    <span>{{ 'Preferences' | transloco }}</span>
  </a>

  <button (click)="signOutModal()" mat-menu-item>
    <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
    <span>{{ 'sign-out' | transloco }}</span>
  </button>
</mat-menu>

<ng-template #signOutDialog>
  <h1 class="pt-2 mb-0" matDialogTitle>{{ 'sign-out' | transloco }}!</h1>
  <mat-divider class="mb-2"></mat-divider>
  <span class="text-secondary"
    >{{ 'In case of logging out of all devices ' | transloco }} <br />
    {{ 'both the unpublished reports & offline observations will be lost' | transloco }}
  </span>
  <mat-dialog-actions *ngIf="!isLoading" align="end">
    <button (click)="signOut('current')" color="primary" mat-button>
      {{ 'current-device' | transloco }}
    </button>
    <button (click)="signOut('all')" color="warn" mat-button>
      {{ 'all-devices' | transloco }}
    </button>
    <button (click)="dialog.closeAll()" color="default" mat-button matDialogClose>
      {{ 'cancel' | transloco }}
    </button>
  </mat-dialog-actions>

  <mat-spinner *ngIf="isLoading" align="end"></mat-spinner>
</ng-template>
